import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, CircularProgress, Box, Typography } from '@mui/joy';
import { AlertCircle } from 'lucide-react';
import KpiWidget from './KpiWidget';
import { getKpiDashboardDataRequest } from '../../../redux/actions/kpiActions';

const DynamicKpiSection = ({ dashboardKey, runtimeFilters = {} }) => {
    const dispatch = useDispatch();
    const { dashboardData, loading, error } = useSelector(state => state.kpi);
    const widgets = Array.isArray(dashboardData?.widgets) ? dashboardData.widgets : [];

    useEffect(() => {
        if (dashboardKey) {
            dispatch(getKpiDashboardDataRequest(dashboardKey, runtimeFilters));
        }
    }, [dashboardKey, dispatch, runtimeFilters]);

    if (loading.dashboardLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4, width: '100%' }}>
                <CircularProgress variant="soft" />
            </Box>
        );
    }

    if (error.dashboardError) {
        return (
            <Box sx={{ p: 2, color: 'danger.main' }}>
                <Typography startDecorator={<AlertCircle />} level="body-sm">
                    Impossible de charger les indicateurs : {error.dashboardError}
                </Typography>
            </Box>
        );
    }

    if (widgets.length === 0) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography level="body-sm" sx={{ color: 'text.secondary' }}>
                    Aucun KPI actif pour ce dashboard.
                </Typography>
            </Box>
        );
    }

    return (
        <Grid container spacing={2}>
            {widgets.map((widget, index) => (
                <Grid 
                    key={widget.configuration.id || index} 
                    xs={12} 
                    md={widget.configuration.width || 4}
                >
                    <KpiWidget 
                        configuration={widget.configuration} 
                        data={widget.data} 
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default DynamicKpiSection;
